module.exports = __webpack_public_path__ + "static/img/texture.763699a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/texture.jpg
// module id = 5n9E
// module chunks = 1